import { render, staticRenderFns } from "./crateStock.vue?vue&type=template&id=6553b9bc"
import script from "./crateStock.vue?vue&type=script&lang=js"
export * from "./crateStock.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports